import React from 'react'
import PostForm from 'Event/Dashboard/components/BlogPosts/PostForm'
import {BlogPostList} from 'Event/template/Lefty/Dashboard/BlogPosts/BlogPostList'
import {BlogPostProps} from 'Event/Dashboard/components/BlogPosts'
import Buttons from 'Event/Dashboard/components/BlogPosts/Buttons'
import Title from 'Event/Dashboard/components/BlogPosts/Title'
import Content from 'Event/Dashboard/components/BlogPosts/Content'
import Date from 'Event/Dashboard/components/BlogPosts/Date'
import Container from 'Event/Dashboard/components/BlogPosts/Container'
import WelcomePostDialog from 'Event/Dashboard/components/BlogPosts/WelcomePostDialog'
import PostStylesConfig from 'Event/template/Lefty/Dashboard/BlogPosts/PostStylesConfig'
import {useLeftyTemplate} from 'Event/template/Lefty'

export default function BlogPosts() {
  return (
    <BlogPostList PostStylesConfig={PostStylesConfig}>
      {(props) => <BlogPost {...props} />}
    </BlogPostList>
  )
}

function BlogPost(props: BlogPostProps) {
  const {post, postId} = props
  const template = useLeftyTemplate()
  const {textColor} = template

  return (
    <>
      <WelcomePostDialog post={post} postId={postId} />
      <Container
        disableSpacing={props.isLast}
        postId={postId}
        textColor={textColor}
      >
        <Title post={post} />
        <Date post={post} />
        <Content post={post} />
        <PostForm post={post} />
        <Buttons post={post} postId={postId} />
      </Container>
    </>
  )
}
